import { router } from 'expo-router';

import type { Command } from './types';

export const newWorkOrderCommand: Command = {
	id: 'new-work-order',
	title: 'New Work Order',
	description: 'Create a new work order',
	icon: 'document-text-outline',
	category: 'create',
	keywords: ['work', 'order', 'job', 'task'],
	action: (closeSearch) => {
		router.push('/work-orders/new');
		closeSearch?.();
	},
};
